import { Injectable, Inject } from '@angular/core';
import { CommunityService } from '@common/services/community.service';
import { API_URL, DEFAULT_COMMUNITY } from '@common/app/app.config';
import { RouteService } from '@common/infrastructure/params-service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Community } from '@common/model/community';
import { take, map, distinctUntilChanged, switchMap, shareReplay } from 'rxjs/operators';
import { Params } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class EnUsCommunityService extends CommunityService {
    url: string;
    constructor(
        http: HttpClient,
        @Inject(API_URL) baseUrl: string,
        @Inject(DEFAULT_COMMUNITY) defaultCommunity: string,
        routeService: RouteService
    ) {
        super(http, baseUrl, defaultCommunity, routeService);
        this.url = baseUrl;
    }

    public reloadCommunityFromUrl(): void {
        this.communityCode$ = this.routeService.aggregatedParams.pipe(
            map((p: Params) => this.getCommunityCodeOrFallback(p)),
            distinctUntilChanged(),
        );
        this.community$ = this.communityCode$.pipe(
            switchMap((code) => this.getCommunity(code)),
            shareReplay(1),
        );
    }

    getCommunityByCode(communityCode: string): Observable<Community> {
        if (communityCode === null || communityCode === undefined) {
            return;
        }
        const url = `${this.url}communities/code/${communityCode}`;
        return this.http.get<Community>(url).pipe(take(1));
    }

    getParticipating$(): Observable<string[]> {
        const url = `${this.url}communities/participating`;

        return this.http.get<string[]>(url).pipe(take(1)).pipe(
            map(l => {
                l.push('other');
                return l;
            })
        );
    }
}
